import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FilteringPage } from 'hse-filtering-library-frontend';
import { useTranslation } from 'react-i18next';
import Page from '@constants/page';
import useGetUploadById from '@api/upload/hooks/useGetUploadById';
import FilteringEntityType from '@constants/filteringEntityType';
import i18n from '@src/i18n';
import UploadOptions from '@components/Upload/UploadOptions/UploadOptions';
import NavigationBreadcrumb from '@components/Navigation/Breadcrumb/NavigationBreadcrumb';
import CustomCellsDefinition, { ColumnName } from './CustomCellsDefinition';

function UploadFileListPage() {
  const [language, setLanguage] = useState(i18n.language);
  const { t } = useTranslation();
  const params = useParams();
  const [refresh, setRefresh] = useState(false);
  const { uploadDTO } = useGetUploadById(Number(params.mainUploadId), {
    enabled: params.mainUploadId !== undefined && !Number.isNaN(params.mainUploadId),
  });

  type RowValueType = {
    [key: string]: string;
  };

  useEffect(() => {
    if (refresh) {
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    if (language !== i18n.language) {
      setLanguage(i18n.language);
    }
  }, [language, t]);

  const customCellRenderer = ({ rowValues, column }: { rowValues: RowValueType; column: any }) => {
    const { key } = column ?? {};
    const value = rowValues[key];
    const renderCustomCell = CustomCellsDefinition[key as ColumnName];
    if (renderCustomCell) {
      return renderCustomCell(rowValues, setRefresh);
    }
    return value;
  };

  if (!uploadDTO) {
    return null;
  }

  return (
    <div className={FilteringEntityType.UPLOAD_FILE}>
      <NavigationBreadcrumb currentPage={Page.FILE_LIST} />
      <UploadOptions uploadDTO={uploadDTO} triggerTableRefresh={setRefresh} />
      <FilteringPage
        type={FilteringEntityType.UPLOAD_FILE}
        customCellRenderer={customCellRenderer}
        additionalArgs={{
          filters: { MAIN_UPLOAD_ID: params.mainUploadId },
        }}
        defaultSort={[{ sortField: 'UPLOAD_TYPE', sortDirection: 'ASC' }]}
        wrapDetailsText
        lang={language}
        showAggregations={false}
        filtersCollapsed
        renderSorting
        showHeaderTooltips={false}
        noFavorites
        noHelpButton
        refreshPage={refresh}
      />
    </div>
  );
}

export default UploadFileListPage;
